import { Action, createReducer, on } from '@ngrx/store';
import * as fromSearchProductSolutionActions from '../actions';
import { IProductSolutionResponse } from '../models/product-solutions.model';

export const searchProductSolutionFeatureKey = 'searchProductSolution';

export interface State {
  loaded: boolean;
  error?: Error | any;
  searchProductSolution: IProductSolutionResponse;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  searchProductSolution: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    fromSearchProductSolutionActions.loadSearchProductSolutions,

    state => state
  ),
  on(fromSearchProductSolutionActions.loadSearchProductSolutionsSuccess, (state, action) => ({
    ...state,
    searchProductSolution: action.response,
    loaded: true
  })),

  on(fromSearchProductSolutionActions.loadSearchProductSolutionsFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectSearchProductSolutions = (state: State) => state.searchProductSolution;
export const selectSearchProductSolutionsLoaded = (state: State) => state.loaded;
export const selectSearchProductSolutionsError = (state: State) => state.error;
